XA.component.teaser = (function ($, document) {
    var api = {};
    api.initInstance = function () {

        function toggleTeaser(){
            var teaserToggleContent = '.teaser-intro';
            var teaserToggleTitle = $('.teaser-intro .teaser-title');

            if ($(window).width() < '992') {
                $(teaserToggleTitle).on('click', function(){
                    if($(this).closest(teaserToggleContent).hasClass('show-conent')){
                        $(this).closest(teaserToggleContent).removeClass('show-conent');
                        $(this).siblings('.teaser-content').hide();
                    }else{
                        $(this).closest(teaserToggleContent).addClass('show-conent');
                        $(this).siblings('.teaser-content').show();
                    }
                });
            }else{
                $(teaserToggleContent).removeClass('show-conent');
                $('.teaser-intro .teaser-content').show();
            }

            
        }

        toggleTeaser();

        var resizeId;
        $(window).resize(function(){
            clearTimeout(resizeId);
            resizeId = setTimeout(toggleTeaser, 500);
        });
        

    };
    api.init = function () {
        api.initInstance();
    };
    return api;
})(jQuery, document);
XA.register("teaser", XA.component.teaser);